import React from 'react';
import { createPortal } from 'react-dom';

const Modal = ({
  title = 'Modal',
  subtitle = '',
  closeModal = true,
  footer = true,
  isOpen = true,
  children,
  setIsOpen = () => {},
  className = '',
  ariaLabel = '',
}) => {
  if (!isOpen) return null;

  // Titleless variants (icon-only alerts) have no heading to point at, so they
  // pass `ariaLabel` instead; otherwise the rendered <h3> names the dialog.
  const dialogLabel = ariaLabel || (typeof title === 'string' ? title : '');

  // Portal to body so the fixed overlay escapes any ancestor that establishes
  // a containing block (transform/overflow) — e.g. the resizable split pane,
  // which otherwise traps the modal inside the pane and behind its scrollbar.
  return createPortal(
    <>
      <div
        className="modal-component flex flex-col items-center justify-center"
        data-testid="modal-component"
      >
        <div
          className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1010]  ${className}`}
        >
          <div
            role="dialog"
            aria-modal="true"
            aria-label={dialogLabel}
            className="bg-white rounded-lg shadow-lg min-w-96 w-fit p-4 max-w-[97vw] max-h-[97vh] relative"
          >
            {title !== '' || subtitle !== '' ? (
              <div className="px-4 py-2 flex justify-between items-center">
                <div className="w-full flex flex-col gap-2">
                  {title !== '' && (
                    <h3
                      className="text-neutral-900 text-xl font-semibold"
                      data-testid="modal-title"
                    >
                      {title}
                    </h3>
                  )}
                  {subtitle !== '' && (
                    <p
                      className="text-slate-700 text-sm"
                      data-testid="modal-subtitle"
                    >
                      {subtitle}
                    </p>
                  )}
                </div>
                {closeModal && (
                  <button
                    type="button"
                    aria-label="Close"
                    onClick={() => setIsOpen(false)}
                    className="text-gray-400 ml-2 hover:text-gray-600 text-3xl"
                  >
                    ×
                  </button>
                )}
              </div>
            ) : (
              closeModal && (
                <button
                  type="button"
                  aria-label="Close"
                  onClick={() => setIsOpen(false)}
                  className="text-gray-400 hover:text-gray-600 text-3xl absolute top-3 right-6"
                >
                  ×
                </button>
              )
            )}
            <div className="p-4">{children}</div>
            {footer && (
              <div className="px-4 py-2 flex justify-end">
                <button
                  onClick={() => setIsOpen(false)}
                  className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 mr-2"
                >
                  Close
                </button>
                <button
                  onClick={() => alert('Action triggered!')}
                  className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                >
                  Confirm
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export { Modal };
export default Modal;
